import { CaretDown, CaretRight } from '@creditornot/cb-icons';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import styled, { css } from 'styled-components';

import { Typography } from 'common/typography';

import { EntityActionItemTitle } from './EntitySelector.styled';
import { ExperienceEntity, ExperienceEntityTree, ExperienceEntityType } from '../../../types';
import { localizedEntityName } from '../../../utils';
import { TextWithHighlightedMatches } from '../../TextWithHighlightedMatches';

const CaretIconCss = css`
  width: 16px;
  height: 16px;
  padding: 2px;
`;
const StyledCaretDown = styled(CaretDown)`
  ${CaretIconCss}
`;

const StyledCaretRight = styled(CaretRight)`
  ${CaretIconCss}
`;

const EntityActionItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 100%;
  align-items: flex-start;
  align-self: stretch;
`;

const IndividualEntityActionItem = ({
  experienceEntityTree,
  selectedExperienceEntity,
  level,
  searchValue,
  handleClickEntity,
}: {
  experienceEntityTree: ExperienceEntityTree;
  selectedExperienceEntity: ExperienceEntity;
  level: number;
  searchValue?: string;
  handleClickEntity: (experienceEntity: ExperienceEntity) => void;
}) => {
  const { locale } = useIntl();
  const [open, setOpen] = useState(true);
  const isSelected =
    selectedExperienceEntity.experienceEntityId === experienceEntityTree.experienceEntity.experienceEntityId;
  return (
    <EntityActionItemContainer
      key={experienceEntityTree.experienceEntity.experienceEntityId}
      style={{ paddingLeft: `${level * 16}px` }}
    >
      <EntityActionItemTitle
        isSelected={isSelected}
        onClick={() => handleClickEntity(experienceEntityTree.experienceEntity)}
      >
        <Typography.Body3>
          <TextWithHighlightedMatches
            text={localizedEntityName(experienceEntityTree.experienceEntity, locale)}
            searchValue={searchValue}
          />
        </Typography.Body3>
        {experienceEntityTree.children.length > 0 && (
          <div
            onClick={event => {
              setOpen(!open);
              event.stopPropagation();
            }}
          >
            {open ? <StyledCaretDown /> : <StyledCaretRight />}
          </div>
        )}
      </EntityActionItemTitle>
      <>
        {open && experienceEntityTree.children.length > 0 && (
          <EntityActionItem
            experienceEntityTreeChildren={experienceEntityTree.children}
            selectedExperienceEntity={selectedExperienceEntity}
            level={level + 1}
            handleClickEntity={handleClickEntity}
            searchValue={searchValue}
          />
        )}
      </>
    </EntityActionItemContainer>
  );
};
export const EntityActionItem = ({
  experienceEntityTreeChildren,
  selectedExperienceEntity,
  level = 0,
  searchValue,
  handleClickEntity,
}: {
  experienceEntityTreeChildren: ExperienceEntityTree[];
  selectedExperienceEntity: ExperienceEntity;
  level: number;
  searchValue?: string;
  handleClickEntity: (experienceEntity: ExperienceEntity) => void;
}) => {
  return experienceEntityTreeChildren
    .filter(experienceEntityTree => {
      if (experienceEntityTree.experienceEntity.experienceEntityType === ExperienceEntityType.VENUE) {
        return experienceEntityTree.experienceEntity.experienceEntityObject.status !== 'VENUE_DELETED';
      }
      return true;
    })
    .map(experienceEntityTree => (
      <IndividualEntityActionItem
        key={experienceEntityTree.experienceEntity.experienceEntityId}
        experienceEntityTree={experienceEntityTree}
        selectedExperienceEntity={selectedExperienceEntity}
        level={level}
        searchValue={searchValue}
        handleClickEntity={handleClickEntity}
      />
    ));
};
